import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { EPaymentsActions, GetPayments, GetPaymentsSuccess, GetPaymentsFailure } from '../actions/payments.actions';
import { PaymentsService } from '../../services/payments.service';
import { PaymentsPaginatorInterface } from '../../models/payments.paginator.interface';
import { Store } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractEffects } from '../../../shared/abstract.effects';

@Injectable()
export class PaymentsEffects extends AbstractEffects {

    currentSelectedPage: number = 0;
    totalItemsPerPage: number = 0;

    constructor(
      private actions: Actions,
      private paymentsService: PaymentsService,
      public override store: Store<any>
    ) {
        super(store);
    }

    getPayments = createEffect(() => this.actions.pipe(
        ofType<GetPayments>(EPaymentsActions.GetPayments),
        tap(params => {
            this.currentSelectedPage = params.currentSelectedPage;
            this.totalItemsPerPage = params.totalItemsPerPage;
        }),
        switchMap(() => this.paymentsService.get(this.currentSelectedPage, this.totalItemsPerPage)),
        switchMap((response: PaymentsPaginatorInterface) => of(new GetPaymentsSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetPayments(this.currentSelectedPage, this.totalItemsPerPage));
            } else {
                this.DisplayMessage('error_with_retry', 400, new GetPaymentsFailure());
            }
            return throwError(error);
        })
    ));
}
